import { render, staticRenderFns } from "./CodecTools.vue?vue&type=template&id=c47342c2"
import script from "./CodecTools.vue?vue&type=script&lang=js"
export * from "./CodecTools.vue?vue&type=script&lang=js"
import style0 from "./CodecTools.vue?vue&type=style&index=0&id=c47342c2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47342c2')) {
      api.createRecord('c47342c2', component.options)
    } else {
      api.reload('c47342c2', component.options)
    }
    module.hot.accept("./CodecTools.vue?vue&type=template&id=c47342c2", function () {
      api.rerender('c47342c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CodecTools.vue"
export default component.exports